import React from "react";
import { Typography } from "./index";
import CurrencyFormatter from "../../services/currencyFormatterService";

interface PerformanceDisplayProps {
  currentValue: number;
  difference: number;
  percentage: number;
  currencyFormatter: CurrencyFormatter;
  showLabel?: boolean;
  labelText?: string;
  className?: string;
}

const PerformanceDisplay: React.FC<PerformanceDisplayProps> = ({
  currentValue,
  difference,
  percentage,
  currencyFormatter,
  showLabel = false,
  labelText = "Current Value",
  className = "",
}) => (
  <div className={`flex flex-col ${className}`}>
    <div className="flex items-center gap-2">
      <Typography
        variant="h2"
        className="text-lg md:text-2xl font-bold text-text-primary"
      >
        {currencyFormatter.format(currentValue, "fiat", "ZAR")}
      </Typography>
      <div className="flex items-center justify-end gap-1">
        <Typography
          variant="span"
          className="text-emerald-500 text-xs md:text-sm font-semibold"
        >
          + {currencyFormatter.format(difference, "fiat", "ZAR")}
        </Typography>
        <Typography
          variant="span"
          className="text-emerald-500 text-xs md:text-sm font-semibold"
        >
          ({percentage.toFixed(0)}%)
        </Typography>
      </div>
    </div>
    {showLabel && (
      <Typography variant="p" className="text-text-secondary">
        {labelText}
      </Typography>
    )}
  </div>
);

export default PerformanceDisplay;
